<template>
    <div class="add modal modal--default">
        <div class="modal__panel" :class="showAddActivityModal ? 'modal__panel--in' : 'modal__panel--out'">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
            </div>
            <div class="modal__close" @click="closeActivityModal"></div>

            <div class="add__new">{{ $t(`addCustomerServiceModal.title`) }}</div>
            <div class="add__title">
                {{ $t(`addCustomerServiceModal.subTitle`) }}
            </div>

            <div class="customers">
                <div v-if="$checkRolePermission('pendency_create')" class="customer" @click="showAddPendencyModal">
                    <div class="customer__icon customer__icon--pendencies"></div> 
                    <button class="add__button button button--default">
                        <span>{{ $t(`addCustomerServiceModal.pendenciesButton`) }}</span>
                    </button>
                </div>

                <div v-if="$checkRolePermission('note_create')" class="customer" @click="showAddNotesModal">
                    <div class="customer__icon customer__icon--notes"></div> 
                    <button class="add__button button button--default">
                        <span>{{ $t(`addCustomerServiceModal.notesButton`) }}</span>
                    </button>
                </div>

                <div v-if="$checkRolePermission('call_create')" class="customer" @click="showAddCallsModal">
                    <div class="customer__icon customer__icon--calls"></div> 
                    <button class="add__button button button--default">
                        <span>{{ $t(`addCustomerServiceModal.callsButton`) }}</span>
                    </button>
                </div>

                <div class="customer" @click="showAddMandateModal">
                    <div class="customer__icon customer__icon--mandat"><i class="fas fa-file-signature"></i></div> 
                    <button class="add__button button button--default">
                        <span>{{ $t(`addCustomerServiceModal.mandateButton`) }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

// Initialize Vuex store context
const store = useStore();

// Computed property from Vuex store state getters
const showAddActivityModal = computed(() => store.getters.showAddActivityModal);

// Modal mutations action handlers
const closeActivityModal = () => {
    store.commit("setShowAddActivityModal", false);
};

const showAddPendencyModal = () => {
    store.commit("setShowAddActivityModal", false);
    store.commit("setShowAddPendencyModal", true);
};

const showAddNotesModal = () => {
    store.commit("setShowAddActivityModal", false);
    store.commit("setShowAddNotesModal", true);
};

const showAddCallsModal = () => {
    store.commit("setShowAddActivityModal", false);
    store.commit("setShowAddCallsModal", true);
};

const showAddMandateModal = () => {
    store.commit("setShowAddActivityModal", false);
    store.commit("setShowAddMandateModal", true);
};
</script>
<style lang="scss" scoped>
@use "../assets/scss/add-panel-modal";
</style>
